var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"fa font_lg",class:_vm.icon + ' ' + _vm.color,attrs:{"aria-hidden":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }